import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Style = styled.div`
    display: grid;
    position: relative;
    grid-template-columns: calc(70px - 1rem) repeat(8, calc(calc(calc(100% - calc(140px)) / 8) - calc(7rem / 8)))  calc(70px - 1rem);
    grid-gap: 1rem;
    grid-template-rows: 0rem repeat(2, calc(calc(100% - 3rem) / 2)) 0rem;
    .logo{
        position: absolute;
        left: 7%;
        top: 1rem;
        width: 15%;
        z-index: 2;
    }
    .data-1 {
        grid-column: 2/10;
        grid-row: 2/4;
        background-color: blue;
        border-radius: 1rem;
        padding: 1rem;
        position: relative;
        overflow: hidden;
        animation: fade-in-anim1 0.6s ease-in-out 1 0s forwards;
    }
    .bg-img {
        position: absolute;
        inset: 0;
        z-index: 0;
        img {
            width: 100%;
            height: 100%;
            display: block;
            object-fit: cover;
        }
        video {
            width: 100%;
            height: 100%;
            display: block;
            object-fit: cover;
        }
        .overlay {
            position: absolute;
            inset: 0;
            background-color: #000000;
            opacity: 0.5;
        }
    }
    .info {
        position: relative;
        z-index: 1;
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        width: 50%;
        padding-left: 7%;
        .title {
            font-size: 3rem;
            font-weight: 800;
            color: #fff;
            position: relative;
            opacity: 0;
            animation: fade-in-anim2 0.8s ease-in-out 1 0.3s forwards;
        }
        .desc {
            margin: 1rem 0;
            font-size: 1rem;
            color: #fff;
            position: relative;
            opacity: 0;
            animation: fade-in-anim2 0.8s ease-in-out 1 0.45s forwards;
        }
        .ctas {
            display: flex;
            gap: 12px;
            position: relative;
            opacity: 0;
            animation: fade-in-anim2 0.8s ease-in-out 1 0.6s forwards;
            .cta {
                cursor: pointer;
                flex-grow: 1;
                border: 1px solid #fff;
                border-radius: 8px;
                font-size: 1.2rem;
                font-weight: 600;
                text-align: center;
                padding: 0.75rem 0;
                color: #fff;
                text-decoration: none;
                &.cta-btn-1 {
                    border: 1px solid var(--prime-2);
                    :hover {
                        background-color: #00000020;
                    }
                }
                &.cta-btn-2 {
                    background-color: var(--prime-2);
                    border: 1px solid var(--prime-2);
                    color: #fff;
                    :hover {
                        background-color: var(--prime-2);
                    }
                }
            }
        }
    }
    @keyframes fade-in-anim1 {
        0% {
            opacity: 0;
            top: 6rem
        }
        100%  {
            opacity: 1;
            top: 0;
        }
    }
    @keyframes fade-in-anim2 {
        0% {
            opacity: 0;
            top: 6rem
        }
        50% {
            opacity: 0;
        }
        100%  {
            opacity: 1;
            top: 0;
        }
    }
    @media (max-width: 850px){
        grid-template-columns: 0 repeat(8, calc(calc(calc(100% - 2rem) / 8) - calc(7rem / 8))) 0;
        grid-template-rows: 0rem repeat(3,calc(calc(100% - 5rem) / 3)) 0rem;
        .logo{
            left: 0;
            top: 0;
            width:40%;
        }
        .data-1 {
            grid-column: 2/10;
            grid-row: 2/5;
            .info {
                height:100%;
                width: 100%;
                justify-content: center;
                padding-left: 0;
                .title {
                    font-size: 2.2rem;
                }
            }
        }
        
    }
`;

export default function IntroSec({pageHeight, data}) {
    const scrollOneScreen = () => {
        window.scrollTo({
            top: pageHeight - 60,
            behavior: "smooth"
        })
    }
    const makeCta = (cta) => {
        switch(cta.type){
            case "scroll":
                return (
                    <div className="cta cta-btn-1" onClick={scrollOneScreen}>
                        {cta.title}
                    </div>
                )
            case "link":
                return (
                    <a href={cta.route} target={cta.target} className="cta cta-btn-2">
                        {cta.title}
                    </a>
                )
            case "link-inside":
                return (
                    <Link to={cta.route} target={cta.target} className="cta cta-btn-2">
                        {cta.title}
                    </Link>
                )
            default:
                return;
        }
    }
    let type = data.data.bgimage.split(".");
    type = type[type.length - 1];
    return (
      <Style style={{height: `${pageHeight -90}px`}}>
        <div className="data-1">
            {
                (data.data.logo) ? (
                    <img src={data.data.logo} alt='logo' className="logo"/>
                ) : ""
            }
            <div className="bg-img">
                {
                    (type === "jpg") ? (
                        <img src={data.data.bgimage} alt={data.title}/>
                    ) : (
                        <video autoPlay loop muted playsInline>
                            <source src={data.data.bgimage} type="video/mp4" />
                        </video>
                    )
                }
                
                <div className="overlay"></div>
            </div>
            <div className="info">
                <div className="title">
                    {data.data.title}
                </div>
                <div className="desc">
                    {data.data.desc}
                </div>
                <div className="ctas">
                    {makeCta(data.data.cta1)}
                    {
                       (data.data.cta2) ? (
                        makeCta(data.data.cta2)
                       ) : ""
                    }
                </div>
            </div>
        </div>
      </Style>
  );
}
